module.exports = __webpack_public_path__ + "static/media/carousel-1.5a5ba8a6.jpg";